<template>
    <div class="akheader">
        <div class="logo-box" :class="widClass">
            <a href="/"><img class="logo" src="https://f0.anyknew.com/static/anyknew-b.png"/></a>
            <div class="l1funcs" :class="{mobile: this.$utils.isMobile()}">
                <div class="func need-space" @click="goRank" >
                    <span class="func-hint" style="font-size:18px; " >热点归档</span>
                    <img class="customize-icon phone" src="../assets/images/past.png" style="margin-left: 3px">
                </div>
<!--                <div class="func need-space" @click="goDlApp" v-if="this.$utils.isMobile()" style="margin-right: 0px;">-->
<!--                    <span class="func-hint" style="font-size:18px; ">APP</span>-->
<!--                    <img class="customize-icon phone" src="../assets/images/phone.png">-->
<!--                </div>-->
            </div>
            <div
              v-if="!this.$utils.isMobile()"
              style="width:421px;
              margin: auto;
              font-size:16px;
              display:flex;
              align-items:center;
              color:#FFF;
              background-image: linear-gradient(#E65F00 0%, #FFE1CC 100%);
              background-size:421px 35px;
              background-repeat:no-repeat;background-position:
              left center;height:35px;">
              <a href="https://www.aliyun.com/minisite/goods?userCode=6gfptdaf" target="_blank">
                <p style="padding-left:15px;color:#FFF">阿里云 2核2G 3M带宽40G云盘 99/年</p>
              </a>
            </div>
            <div class="l2funcs" v-if="!this.$utils.isMobile()">
                <div class="func" @click="goBespoke" v-if="isLogined === false">
                    <span class="func-hint"></span>
                    <img class="customize-icon" src="../assets/images/customize.png">
                </div>
                <div class="func" v-else>
                    <div class="avatar-box">
                        <img class="user-avatar" :src="profile.avatar" @click="showingMenu = true">
                        <div class="user-menus" v-if="showingMenu">
                            <div class="menu-item" @click="goBespoke">
                                定制站点
                            </div>
                            <hr color="#F2F2F2" size="1">
                            <div class="menu-item" @click="logout">
                                退出
                            </div>
                        </div>
                        <div class="user-mask" v-if="showingMenu" @click="showingMenu = false">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/* eslint-disable */
import akwxlogin from './AKWXLogin.vue'
import router from "../router";
export default {
  name: 'akheader',
  components: {akwxlogin},
  data () {
    return {
      logo: 'https://f0.anyknew.com/static/anyknew.png',
      widClass: 'small',
      showWxLogin: false,
      isLogined: false,
      profile: {},
      showingMenu: false,
    }
  },
  created: function () {
    var that = this
    if(localStorage.getItem('logined') === 'yes'){
      this.isLogined = true
      this.$http.get('/self/profile', {}, function (r) {
        if (r.status === 0) {
          that.profile = r.data.profile
        }
      })
    }
    else{
      this.isLogined = false
    }
    this.setWidPara()
  },
  computed: {
  },
  methods: {
    goDlApp: function () {
      this.$router.push('/app')
    },
    goRank: function () {
      window.location.href = 'https://www.anyknew.com/rankings'
    },
    goBespoke: function () {
      // window.location.href = 'https://www.anyknew.com/wx/web/login'
      // window.location.href = 'http://192.168.4.216:4700/wx/web/login'
      if(localStorage.getItem('logined') === 'yes'){
        this.$router.push('/bespoke')
      }
      else{
        window.location.href = 'https://www.anyknew.com/wx/web/login'
      }
      this.showingMenu = false
    },
    showUserMenu: function () {

    },
    hideUserMenu: function () {

    },
    setWidPara: function (){
      // var _width = screen.width
      var _width = document.body.clientWidth
      //ipad resolution
      //Portrait: 768x946
      //Landscape: 1024x690
      if(_width < 500){
        this.widClass = 'mobile'
      }
      else if(_width <= 770){
        this.widClass = 'xxsmall'
      }
      else if(_width <= 1150){
        this.widClass = 'xsmall'
      }
      else if(_width <= 1500){
        this.widClass = 'small'
      }
      else if(_width <= 2050){
        this.widClass = 'middle'
      }
      else if(_width > 2050){
        this.widClass = 'large'
      }
    },
    logout: function () {
      localStorage.removeItem('logined')
      localStorage.removeItem('aker')
      var urls = this.$http.apiUrls()
      console.log(urls.root)
      window.location.href = urls.root + '/logout'
    },
  }

}
</script>
<style lang="less">
.akheader{
    width: 100%;
    background-color: #FFFFFF;
    text-align: center;
    margin: auto;
    .logo-box{
        &.mobile{
            width: 100%;
        }
        &.xxsmall{
            width: 740px;
        }
        &.xsmall{
            width: 990px;
        }
        &.small{
            width: 1120px;
        }
        &.middle{
            width: 1520px;
        }
        &.large{
            width: 1900px;
        }
        display: flex;
        align-items: center;
        justify-content: center;
        margin: auto;
        .logo{
            width: 150px;
            padding: 5px 0;
        }
        .l1funcs, .l2funcs{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .func{
                display: flex;
                align-items: center;
                cursor: pointer;
                &.need-space{
                    /*margin-right: 30px;*/
                }
                .customize-icon{
                    /*width: 15px;*/
                    height: 20px;
                    margin-left: 3px;
                    &.phone{
                        margin-left: -1px;
                    }
                }
                .func-hint{
                    font-size: 15px;
                    letter-spacing: 2px;
                    color: #3DB4F1;
                }
                .avatar-box{
                    position: relative;
                    margin-left: 20px;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    .user-avatar{
                        border-radius: 50%;
                        width: 40px;
                    }
                    .user-mask{
                        display: block;
                        background-color: rgba(20,20,20,.3);
                        position: fixed;
                        width: 100%;
                        height: 100%;
                        top: 0;
                        left: 0;
                        z-index: 41;
                    }
                    .user-menus{
                        position: absolute;
                        right: -40px;
                        top: 40px;
                        margin-top: 15px;
                        width: 120px;
                        height: 101px;
                        background-color: #FFF;
                        z-index: 51;
                        font-size: 2.3em;
                        letter-spacing: 5px;
                        .menu-item{
                            color: #3DB4F1;
                            line-height: 50px;
                            text-align: center;
                            font-size: 1.1rem;
                            a{
                                color: #3DB4F1;
                            }
                        }
                        &:before{
                            content: '';
                            width: 0;
                            height: 0;
                            border: 10px solid transparent;
                            border-bottom-color: #FFF;
                            position: absolute;
                            top: 0;
                            right: 50px;
                            margin-top: -20px;
                        }
                    }
                }
            }
        }
        .l1funcs{
            flex: 1;
            justify-content: flex-start;
            padding-left: 50px;
            &.mobile{
                padding-right: 10px;
                justify-content: flex-end;
            }
        }
        .l2funcs{
            width: 250px;
        }
    }
}
</style>
